// export function gtag_report_conversion(url) {
//     const callback = function () {
//       if (typeof url !== 'undefined') {
//         window.location = url;
//       }
//     };
//     if (typeof window.gtag !== 'undefined') {
//       window.gtag('event', 'conversion', {
//         send_to: 'AW-11433321748/mzG5CLa36r0aEJTK6ssq',
//         event_callback: callback,
//       });
//     }
//     return false;
//   }

export function gtag_report_conversion(phoneNumber) {
  if (typeof window.gtag !== "undefined") {
    window.gtag("event", "conversion", {
      send_to: "AW-11433321748/mzG5CLa36r0aEJTK6ssq",
    });
  }

  // Proceed to phone call immediately to preserve user gesture
  window.location.href = `tel:${phoneNumber}`;
}
